export const capitalizeFirstLetter = (str) => {
  if (str.length === 0) return "";
  return str[0].toUpperCase() + str.slice(1);
};

export const isValidPhoneNumber = (inputtxt) => {
  var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (phoneno.test(inputtxt)) {
    return true;
  }
  return false;
};

export const isValidEmailAddress = (inputtxt) => {
  var email =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
  if (email.test(inputtxt)) {
    return true;
  }

  return false;
};

export const isValidDateOfBirth = (inputtxt) => {
  var dob = /((0[1-9]|1[0-2])\/((0|1)[0-9]|2[0-9]|3[0-1])\/((19|20)\d\d))$/;

  if (dob.test(inputtxt)) {
    var parts = inputtxt.split("/");
    let date = new Date(parts[2], parts[1], parts[0]);
    if (date < new Date()) {
      return true;
    }
  }

  return false;
};

export const isValidSSN = (inputtxt) => {
  var ssn = /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/;

  if (ssn.test(inputtxt)) {
    return true;
  }

  return false;
};

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const dateFormat = (d) => {
  var t = new Date(d);
  return  monthNames[t.getMonth()] + ' ' + t.getDate()+ ', '+ t.getFullYear();
}
